export default __webpack_public_path__ + "static/media/webtoon.0a9d7b49.svg";